export function getFormattetCardNumber(value: string | undefined): RegExpMatchArray | null {
    if (value === undefined) {
        return [];
    }

    return value.replace(/X/g, '*').match(/.{1,4}/g);
}
